import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@vapor/material'
import { useReactiveVar } from '@apollo/client'
import { confirmDialogVar } from './confirm-reactive-var'
import { useCallback } from 'react'

export default function ConfirmProvider(props: { children?: React.ReactNode }) {
  const confirmDialogs = useReactiveVar(confirmDialogVar)
  const closeDialog = useCallback((key: string) => {
    confirmDialogVar(confirmDialogVar().filter((d) => d.key !== key))
  }, [])

  return (
    <>
      {props.children}
      {confirmDialogs.map((d) => {
        return (
          <Dialog
            open
            key={d.key}
            onClose={() => {
              d.onCancel?.()
              closeDialog(d.key)
            }}
          >
            <DialogTitle>{d.title}</DialogTitle>
            <DialogContent>
              <DialogContentText>{d.message}</DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                variant="outlined"
                onClick={() => {
                  d.onCancel?.()
                  closeDialog(d.key)
                }}
              >
                {d.cancelButtonText}
              </Button>
              <Button
                variant="contained"
                color={d.confirmIsDanger ? 'error' : undefined}
                onClick={() => {
                  d.onConfirm()
                  closeDialog(d.key)
                }}
              >
                {d.confirmButtonText}
              </Button>
            </DialogActions>
          </Dialog>
        )
      })}
    </>
  )
}
